// extracted by mini-css-extract-plugin
export default {"noteButton":"Button_noteButton__6t56x"};